import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: '2em',
    marginBottom: '0',
  },
  label: {
    display: 'block',
    padding: '0 24px',
    textAlign: 'center',
    fontSize: '0.7rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: theme.palette?.custom?.sidebarGroupLabel,
    letterSpacing: '0.18em',
  },
  divider: {
    width: '100%',
    border: 'medium',
    height: '1px',
    marginTop: '1em',
    background: theme.palette?.custom?.sidebarGroupLabelDivider,
  },
}));

type SidebarGroupLabelProps = {
  children: React.ReactNode;
};

export const SidebarGroupLabel = ({ children }: SidebarGroupLabelProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.label}>{children}</span>
      <hr className={classes.divider} />
    </div>
  );
};
